// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_actions.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for launching phone applications and navigating to URLs.
// </summary>
// ***********************************************************************

window.actions = window.actions || {};

/**
 * Launches the device's phone application with the provided phone number.
 * This function constructs a `tel:` URL scheme and redirects the browser to it,
 * triggering the phone app on most mobile devices.
 *
 * @function launchPhoneApplication
 * @memberof window.actions
 * @param {string} phoneNumber - The phone number to dial. Must be a valid phone number string.
 */
window.actions.launchPhoneApplication = function (phoneNumber) {
    window.location.href = 'tel:' + phoneNumber;
};

/**
 * Navigates the current browser window to the specified URL.
 * This function changes the `window.location.href` to the given URL, effectively
 * redirecting the user to the new location.
 *
 * @function navigateToUrl
 * @memberof window.actions
 * @param {string} url - The destination URL to which the browser should navigate.
 */
window.actions.navigateToUrl = function (url) {
    window.location.href = url;
};


/**
 * Closes the current browser tab or window.
 * This function attempts to close the browser window using `window.close()`.
 * Note: Most modern browsers restrict this behavior unless the tab was opened
 * programmatically or the action is triggered by user interaction.
 *
 * @function closeBrowserTab
 * @memberof window.actions
 */
window.actions.closeBrowserTab = function () {
    window.close();
};